import { getInitials } from '@cloud/shared/ui'
import { Link } from '@tanstack/react-router'
import { useTranslations } from 'gt-react'
import { LogOut, UserCog } from 'lucide-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useUser } from '@/providers/user-provider'

export function UserDropdown() {
  const t = useTranslations('navigation.userNav')
  const { logout, current } = useUser()

  if (!current) {
    return (
      <Button variant="outline" size="icon" className="rounded-lg" aria-label="User">
        <Avatar className="size-9">
          <AvatarFallback className="bg-transparent">!</AvatarFallback>
        </Avatar>
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="rounded-lg" aria-label="User">
          <Avatar className="size-9">
            <AvatarImage src={'#'} alt="" />
            <AvatarFallback className="bg-transparent">
              {current?.user?.name && getInitials(current.user.name ?? 'U')}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent forceMount>
        <DropdownMenuLabel className="flex gap-2">
          <Avatar>
            <AvatarImage src={'#'} alt="Avatar" />
            <AvatarFallback className="bg-transparent">
              {current?.user?.name && getInitials(current.user.name ?? 'U')}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col overflow-hidden">
            <p className="text-sm font-medium truncate">{current?.user?.name}</p>
            <p className="text-xs text-muted-foreground font-semibold truncate">{current?.user?.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup className="max-w-48">
          <DropdownMenuItem asChild>
            <Link to="/settings">
              <UserCog className="me-2 size-4" />
              {t('settings')}
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => logout()}>
          <LogOut className="me-2 size-4" />
          {t('signOut')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
